<template>
  <el-button @click="showFlowChartBtn">{{text}}</el-button>
</template>
<script>
export default {
  props: {
    flowId: {},
    text: {
      default: '预览流程图'
    }
  },
  data() {
    return {
      user: this.$store.state.user.userInfo
    };
  },
  methods: {
    showFlowChartBtn: function() {
      window.open('/flowchart/view/' + this.flowId);
    }
  }
};
</script>
